import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import settings from './profileSettings/profileSettings.reducer.index';
import user from './user/user.reducer.index';
import activeCrops from './activeCrops/activeCrops.reducer.index';
import archiveActiveCrop from './archiveActiveCrop/archiveActiveCrop.reducer.index';
import editCrop from './editActiveCrop/editActiveCrop.reducer.index';
import archivedCrops from './archivedCrops/archivedCrops.reducer.index';
import activeArchivedCrop from './activeArchivedCrops/activeArchivedCrops.reducer.index';
import archiveCropsPaginationInfo from './archivedCrops/activePage.reducer.index';
import crops from './crops/crops.reducer.index';
import cropInfo from './crop/crop.reducer.index';
import activeSegments from './activeSegments/activeSegments.reducer.index';
import archivedSegments from './archivedSegments/archivedSegments.reducer.index';
import archivedSegmentsPaginationInfo from './archivedSegments/activePage.reducer.index';
import archiveActiveSegment from './archiveActiveSegment/archiveActiveSegment.reducer.index';
import activeArchivedSegment from './activeArchivedSegment/activeArchivedSegment.reducer.index';
import issue from './issue/issue.reducer.index';
import languages from './languages/languages.reducer.index';
import segmentList from './segmentList/segmentList.reducer.index';
import activeCropIssues from './activeCropIssues/activeCropIssues.reducer.index';
import segment from './segment/segment.reducer.index';
import products from './products/products.reducer.index';
import archivedCropIssues from './archivedCropIssues/archivedCropIssues.reducer.index';
import cropStats from './cropStats/cropStats.reducer.index';
import cropSchedule from './cropSchedules/cropSchedules.reducer.index';
import cropScheduleList from './cropScheduleList/cropScheduleList.reducer.index';
import scheduleInfo from './scheduleInfo/scheduleInfo.reducer.index';
import scheduleHistory from './scheduleHistory/scheduleHistory.reducer.index';
import irrigationTypes from './irrigationTypes/irrigationTypes.reducer.index';
import soilTypes from './soilTypes/soilTypes.reducer.index';
import kit from './kit/kit.reducer.index';
import seasons from './seasons/seasons.reducer.index';
import basicDetails from './basicDetails/basicDetails.reducer.index';
import sowingDetails from './sowingDetails/sowingDetails.reducer.index';
import state from './region/state.reducer.index';
import district from './region/district.reducer.index';
import taluka from './region/taluka.reducer.index';
import stages from './stages/stages.reducer.index';
import tasks from './tasks/tasks.reducer.index';
import taskTypes from './taskTypes/taskTypes.reducer.index';
import taskDetails from './taskDetails/taskDetails.reducer.index';
import taskProductsList from './taskProducts/taskProducts.reducer.index';
import taskSms from './taskSmsAndIssue/taskSmsAndIssue.reducer.index';
import unit1 from './units/unit1.reducer.index';
import unit2 from './units/unit2.reducer.index';
import sms from './sms/sms.reducer.index';
import stageIssue from './stageIssue/stageIssue.reducer.index';
import cropIssueList from './cropIssueList/cropIssueList.reducer.index';
import validSchedule from './validPOPSchedule/validPOPSchedule.reducer.index';
import stageIssueDetails from './stageIssueDetails/stageIssueDetails.reducer.index';
import cloneSchedule from '../routes/scheduleReadInfo/cloneSchedule/cloneSchedule.reducer.index';
import createdSegmentList from '../routes/scheduleReadInfo/cloneSchedule/createdSegment.reducer.index';
import undoCloneSchedule from '../routes/scheduleDetails/createSchedule/undoClone/undoClone.reducer.index';

export default combineReducers({
  form: formReducer,
  settings,
  user,
  activeCrops,
  archiveActiveCrop,
  editCrop,
  archivedCrops,
  activeArchivedCrop,
  archiveCropsPaginationInfo,
  crops,
  cropInfo,
  activeSegments,
  archivedSegments,
  archivedSegmentsPaginationInfo,
  archiveActiveSegment,
  activeArchivedSegment,
  issue,
  languages,
  segmentList,
  activeCropIssues,
  segment,
  products,
  archivedCropIssues,
  cropStats,
  cropSchedule,
  cropScheduleList,
  scheduleInfo,
  scheduleHistory,
  irrigationTypes,
  soilTypes,
  kit,
  seasons,
  basicDetails,
  sowingDetails,
  state,
  district,
  taluka,
  stages,
  tasks,
  taskTypes,
  taskDetails,
  taskProductsList,
  taskSms,
  unit1,
  unit2,
  sms,
  stageIssue,
  cropIssueList,
  validSchedule,
  stageIssueDetails,
  cloneSchedule,
  createdSegmentList,
  undoCloneSchedule,
});
